import { useMemo } from 'react'
import { useGetList, useGetIdentity } from 'react-admin'

// Fetches facultes + nested facultes_mineures from DB for the current user's center
// Returns the same shape as the former hardcoded FAC_CATALOGUE / FAC_MAPPING / FAC_BY_LABEL
const useFacsCatalogue = ({ allCenters = false } = {}) => {
	const { data: identity } = useGetIdentity()
	const centerId = identity?.center?.id

	const facsResource = allCenters ? 'facultes_catalogue_view' : 'facultes'
	const mineuresResource = allCenters ? 'facultes_mineures_catalogue_view' : 'facultes_mineures'

	const { data: facsRaw, isLoading: facsLoading, refetch: refetchFacs } = useGetList(
		facsResource,
		{
			pagination: { page: 1, perPage: 200 },
			sort: { field: 'sort_order', order: 'ASC' },
			filter: centerId && !allCenters ? { center_id: centerId } : {},
		},
		{ enabled: allCenters || !!centerId }
	)

	const { data: catalogueRaw, isLoading: catalogueLoading, refetch: refetchCatalogue } = useGetList(
		mineuresResource,
		{
			pagination: { page: 1, perPage: 1000 },
			sort: { field: 'sort_order', order: 'ASC' },
		},
		{ enabled: (allCenters || !!centerId) && !facsLoading && facsRaw?.length > 0 }
	)

	const isLoading = facsLoading || catalogueLoading

	const { facs, facMapping, facByLabel } = useMemo(() => {
		if ( !facsRaw ) return { facs: [], facMapping: {}, facByLabel: {} }

		const catalogueByFac = {}
		if ( catalogueRaw ) {
			catalogueRaw.forEach(entry => {
				if ( !catalogueByFac[entry.faculte_id] ) catalogueByFac[entry.faculte_id] = []
				catalogueByFac[entry.faculte_id].push({ id: entry.id, name: entry.name })
			})
		}

		const facList = facsRaw.map(fac => ({
			id: fac.id,
			label: fac.name,
			color: fac.color || '#999999',
			mineures: catalogueByFac[fac.id] || [],
		}))

		const mapping = {}
		const byLabel = {}
		facList.forEach(fac => {
			byLabel[fac.label] = fac
			fac.mineures.forEach(min => {
				mapping[min.name] = fac
			})
		})

		return { facs: facList, facMapping: mapping, facByLabel: byLabel }
	}, [facsRaw, catalogueRaw])

	const refetch = () => {
		refetchFacs()
		refetchCatalogue()
	}

	return { facs, facMapping, facByLabel, isLoading, refetch }
}

export default useFacsCatalogue
